import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {AnalysisPdfSummary} from './analysisSummary.types'

export const QueryKey = 'analysis-pdfsummary'

export const useGetAnalysisPdfSummary = (
  analysisId: number,
  options?: UseQueryOptions<AnalysisPdfSummary, AxiosError>
) => {
  return useQuery<AnalysisPdfSummary, AxiosError>({
    queryKey: [QueryKey, analysisId],
    queryFn: async () => {
      const path = `/rootcausefailureanalysis/analyses/${analysisId}/tree/pdfsummary`
      return (await ApiClient.axiosInstance.get<AnalysisPdfSummary>(path)).data
    },
    // these default values will get moved to the api provider soon
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    throwOnError: true,
    retry: false,

    // allow the callee to override the default options
    ...options
  })
}
